import { z } from "zod";

import {
  DeployedFlowIntrospectionSchema,
  DeployedFlowIntrospectionV1Schema,
} from "./schemas";
import type { DeployedFlowIntrospection } from "./types";

const AnyDeployedFlowIntrospectionSchema = z.discriminatedUnion(
  "schemaVersion",
  [DeployedFlowIntrospectionV1Schema, DeployedFlowIntrospectionSchema],
);

/**
 * Parse a snapshot of any supported schema version into the current shape.
 *
 * A v1 snapshot is the current shape without `loading`, so upgrading it is
 * lossless.
 */
export function parseDeployedFlowIntrospection(
  payload: unknown,
): DeployedFlowIntrospection {
  const snapshot = AnyDeployedFlowIntrospectionSchema.parse(payload);
  return snapshot.schemaVersion === 1
    ? { ...snapshot, schemaVersion: 2 }
    : snapshot;
}
